import HTMLParsedElement from "html-parsed-element"
import toggleAttribute from "./toggleAttribute"
import { morphdomIgnore } from "web-ui/morphdom/ignore"
import { morphdomPreserveAttributes } from "web-ui/morphdom/preserve-attributes"
import { afterPageRender } from "web-ui/after-page-render"
import * as Log from "web-ui/log"

class PersistentFooter extends HTMLParsedElement {
  constructor() {
    super()

    this.observer = new IntersectionObserver(
      ([event]) => {
        const sentinelVisible = event.isIntersecting

        if (sentinelVisible) {
          this.undock()
        } else {
          this.dock()
        }

        // The "loaded" attribute enables animation, which should not be done until
        // after the initial render so as to avoid a flash
        // - Antoine, Shaun, Mon Mar 17 2025
        if (this.getAttribute("loaded") == null) {
          afterPageRender(() => {
            this.debug("Adding loaded class")

            toggleAttribute(this, "loaded", true)

            this.debug("Added loaded class")
          })
        }
      },
      { threshold: 1 }
    )
  }

  parsedCallback() {
    this.debug("Parsed")

    this.createAndObserveSentinelElement()

    morphdomPreserveAttributes(this, ["docked", "undocked", "loaded"])
  }

  disconnectedCallback() {
    this.observer.disconnect()
    this.sentinelElement.remove()
  }

  createAndObserveSentinelElement() {
    this.debug("Creating and observing sentinel element")

    this.sentinelElement = document.createElement("div")
    this.sentinelElement.classList.add("persistent-footer-sentinel")

    morphdomIgnore(this.sentinelElement, true)

    this.after(this.sentinelElement)

    this.observer.observe(this.sentinelElement)

    this.debug("Created and observing sentinel element")
  }

  dock() {
    this.debug("Docking", { classes: this.classList.toString() })

    toggleAttribute(this, "docked", true)
    toggleAttribute(this, "undocked", false)

    this.debug("Docked", { classes: this.classList.toString() })
  }

  undock() {
    this.debug("Undocking", { classes: this.classList.toString() })

    toggleAttribute(this, "undocked", true)
    toggleAttribute(this, "docked", false)

    this.debug("Undocked", { classes: this.classList.toString() })
  }

  debug(message, data) {
    Log.debug("Persistent Footer - " + message, data)
  }
}

if (!window.customElements.get("persistent-footer")) {
  window.PersistentFooter = PersistentFooter
  window.customElements.define("persistent-footer", PersistentFooter)
}
